import React, { useState, useRef } from "react";
import "./LineInformation.css";
import { LineInformationPoints } from "../../../Utils/constants";
import { LineInformationVar } from "../../../Utils/variables";
import { CheckCircleTwoTone, copy } from "../../../Utils/imports";
import { CheckCircleOutlined } from "../../../Utils/imports";
import ButtonComp from "../../ButtonComp/ButtonComp";
// import {PapaParse, CSVLink} from 'papaparse'
import { useSelector, useDispatch } from "react-redux";
import { LineInformationLogs } from "../../../API-Interaction/apiServices/logs.api"
import moment from "moment";
import { apiRoutes } from "../../../API-Interaction/apiRoutes"
import { access_capabilities } from "../../../Utils/constants";
import { canPerformAction } from "../../../Helpers/helpers"
import { APIRestPointsVar } from "../../../Utils/variables";
import { getRequest, postRequest } from "../../../API-Interaction/apiMethods";
import {
  Col,
  Row,
  Form,
  Input,
  Select,
  Tag,
} from "antd";
import { onDowntimeValuesSubmit } from "../../../API-Interaction/apiServices/productionLine.api";

const {
  line,
  target_oee,
  defaultMachine,
  timeZone,
  hallNAme,
  importReason,
  machineName,
} = LineInformationVar;

const timeZones = { "(GMT-11:00) Pago Pago": "Pacific/Pago_Pago", "(GMT-10:00) Hawaii Time": "Pacific/Honolulu", "(GMT-08:00) Pacific Time": "America/Los_Angeles", "(GMT-08:00) Pacific Time - Tijuana": "America/Tijuana", "(GMT-07:00) Mountain Time": "America/Denver", "(GMT-07:00) Mountain Time - Arizona": "America/Phoenix", "(GMT-07:00) Mountain Time - Chihuahua, Mazatlan": "America/Mazatlan", "(GMT-06:00) Central Time": "America/Chicago", "(GMT-06:00) Central Time - Mexico City": "America/Mexico_City", "(GMT-06:00) Central Time - Regina": "America/Regina", "(GMT-06:00) Guatemala": "America/Guatemala", "(GMT-05:00) Bogota": "America/Bogota", "(GMT-05:00) Eastern Time": "America/New_York", "(GMT-05:00) Lima": "America/Lima", "(GMT-04:30) Caracas": "America/Caracas", "(GMT-04:00) Atlantic Time - Halifax": "America/Halifax", "(GMT-04:00) Guyana": "America/Guyana", "(GMT-04:00) La Paz": "America/La_Paz", "(GMT-03:00) Buenos Aires": "America/Argentina/Buenos_Aires", "(GMT-03:00) Godthab": "America/Godthab", "(GMT-03:00) Montevideo": "America/Montevideo", "(GMT-03:30) Newfoundland Time - St. Johns": "America/St_Johns", "(GMT-03:00) Santiago": "America/Santiago", "(GMT-02:00) Sao Paulo": "America/Sao_Paulo", "(GMT-02:00) South Georgia": "Atlantic/South_Georgia", "(GMT-01:00) Azores": "Atlantic/Azores", "(GMT-01:00) Cape Verde": "Atlantic/Cape_Verde", "(GMT+00:00) Casablanca": "Africa/Casablanca", "(GMT+00:00) Dublin": "Europe/Dublin", "(GMT+00:00) Lisbon": "Europe/Lisbon", "(GMT+00:00) London": "Europe/London", "(GMT+00:00) Monrovia": "Africa/Monrovia", "(GMT+01:00) Algiers": "Africa/Algiers", "(GMT+01:00) Amsterdam": "Europe/Amsterdam", "(GMT+01:00) Berlin": "Europe/Berlin", "(GMT+01:00) Brussels": "Europe/Brussels", "(GMT+01:00) Budapest": "Europe/Budapest", "(GMT+01:00) Central European Time - Belgrade": "Europe/Belgrade", "(GMT+01:00) Central European Time - Prague": "Europe/Prague", "(GMT+01:00) Copenhagen": "Europe/Copenhagen", "(GMT+01:00) Madrid": "Europe/Madrid", "(GMT+01:00) Paris": "Europe/Paris", "(GMT+01:00) Rome": "Europe/Rome", "(GMT+01:00) Stockholm": "Europe/Stockholm", "(GMT+01:00) Vienna": "Europe/Vienna", "(GMT+01:00) Warsaw": "Europe/Warsaw", "(GMT+02:00) Athens": "Europe/Athens", "(GMT+02:00) Bucharest": "Europe/Bucharest", "(GMT+02:00) Cairo": "Africa/Cairo", "(GMT+02:00) Jerusalem": "Asia/Jerusalem", "(GMT+02:00) Johannesburg": "Africa/Johannesburg", "(GMT+02:00) Helsinki": "Europe/Helsinki", "(GMT+02:00) Kiev": "Europe/Kiev", "(GMT+02:00) Moscow-01 - Kaliningrad": "Europe/Kaliningrad", "(GMT+02:00) Riga": "Europe/Riga", "(GMT+02:00) Sofia": "Europe/Sofia", "(GMT+02:00) Tallinn": "Europe/Tallinn", "(GMT+02:00) Vilnius": "Europe/Vilnius", "(GMT+03:00) Istanbul": "Europe/Istanbul", "(GMT+03:00) Baghdad": "Asia/Baghdad", "(GMT+03:00) Nairobi": "Africa/Nairobi", "(GMT+03:00) Minsk": "Europe/Minsk", "(GMT+03:00) Riyadh": "Asia/Riyadh", "(GMT+03:00) Moscow+00 - Moscow": "Europe/Moscow", "(GMT+03:30) Tehran": "Asia/Tehran", "(GMT+04:00) Baku": "Asia/Baku", "(GMT+04:00) Moscow+01 - Samara": "Europe/Samara", "(GMT+04:00) Tbilisi": "Asia/Tbilisi", "(GMT+04:00) Yerevan": "Asia/Yerevan", "(GMT+04:30) Kabul": "Asia/Kabul", "(GMT+05:00) Karachi": "Asia/Karachi", "(GMT+05:00) Moscow+02 - Yekaterinburg": "Asia/Yekaterinburg", "(GMT+05:00) Tashkent": "Asia/Tashkent", "(GMT+05:30) Colombo": "Asia/Colombo", "(GMT+06:00) Almaty": "Asia/Almaty", "(GMT+06:00) Dhaka": "Asia/Dhaka", "(GMT+06:30) Rangoon": "Asia/Rangoon", "(GMT+07:00) Bangkok": "Asia/Bangkok", "(GMT+07:00) Jakarta": "Asia/Jakarta", "(GMT+07:00) Moscow+04 - Krasnoyarsk": "Asia/Krasnoyarsk", "(GMT+08:00) China Time - Beijing": "Asia/Shanghai", "(GMT+08:00) Hong Kong": "Asia/Hong_Kong", "(GMT+08:00) Kuala Lumpur": "Asia/Kuala_Lumpur", "(GMT+08:00) Moscow+05 - Irkutsk": "Asia/Irkutsk", "(GMT+08:00) Singapore": "Asia/Singapore", "(GMT+08:00) Taipei": "Asia/Taipei", "(GMT+08:00) Ulaanbaatar": "Asia/Ulaanbaatar", "(GMT+08:00) Western Time - Perth": "Australia/Perth", "(GMT+09:00) Moscow+06 - Yakutsk": "Asia/Yakutsk", "(GMT+09:00) Seoul": "Asia/Seoul", "(GMT+09:00) Tokyo": "Asia/Tokyo", "(GMT+09:30) Central Time - Darwin": "Australia/Darwin", "(GMT+10:00) Eastern Time - Brisbane": "Australia/Brisbane", "(GMT+10:00) Guam": "Pacific/Guam", "(GMT+10:00) Moscow+07 - Magadan": "Asia/Magadan", "(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk": "Asia/Vladivostok", "(GMT+10:00) Port Moresby": "Pacific/Port_Moresby", "(GMT+10:30) Central Time - Adelaide": "Australia/Adelaide", "(GMT+11:00) Eastern Time - Hobart": "Australia/Hobart", "(GMT+11:00) Eastern Time - Melbourne, Sydney": "Australia/Sydney", "(GMT+11:00) Guadalcanal": "Pacific/Guadalcanal", "(GMT+11:00) Noumea": "Pacific/Noumea", "(GMT+12:00) Majuro": "Pacific/Majuro", "(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy": "Asia/Kamchatka", "(GMT+13:00) Auckland": "Pacific/Auckland", "(GMT+13:00) Fakaofo": "Pacific/Fakaofo", "(GMT+13:00) Fiji": "Pacific/Fiji", "(GMT+13:00) Tongatapu": "Pacific/Tongatapu", "(GMT+14:00) Apia": "Pacific/Apia" }
const { Option } = Select;
const LineInformation = () => {
  
  const [data, setData] = useState([]);
  const { current = null } = useSelector(state => state.plant)
  let {plant = null, machine = null} = current;
  //let { plant = null, line = null, machine = null } = JSON.parse(localStorage.getItem('current'))
  if(machine?.displayName == 'Default'){
    machine = null;
  }
  let lineInfoData = {
    productionLineId: current?.line?.id,
    sensorKey: current?.line?.endpoint,
    primaryKey:current?.line?.deviceKey,
    lineName: current?.line?.lineName,
    hallName: current?.line?.hallName,
    targetOee: current?.line?.targetOee,
    lineStatus: current?.line?.status,
  }
  console.log(current)
  const [copied, setCopied] = useState({
    flag: false,
    value: null
  })
  function copyText(id) {
    var copyText = document.getElementById(`input${id}`);

    navigator.clipboard.writeText(copyText.value);
    setTimeout(() => {
      setCopied({ flag: false, value: null })
    }, 1000);
    setCopied({ flag: true, value: id })
  }


  const RestLineInformationPoints = LineInformationPoints.map((endpoint, index) => (
    <Form.Item
      key={endpoint.id}
      label={
        <div className="dflex alignCenter">
          <p className="IARP-form-label">{endpoint.title}</p>
          <img src={copy} className="copy-icon" onClick={() => copyText(endpoint.id)} />
          {
            copied.flag ? <>{endpoint.id === copied.value ? <> <span style={{ fontSize: "12px" }}>&nbsp;&nbsp;Copied&nbsp;<CheckCircleTwoTone twoToneColor="#52c41a" /></span>  </> : <></>}</> : <></>
          }
        </div>
      }
      name={endpoint.title}
    >
      <Input
        className="IARP-form-input boxBorder boxBorderRad boxBg"
        defaultValue={endpoint.id==1?lineInfoData.productionLineId:endpoint.id==2?lineInfoData.sensorKey:endpoint.id==3?lineInfoData.primaryKey:endpoint.data}
        readOnly={true}
        id={`input${endpoint.id}`}
      />
    </Form.Item>
  ));
  const csvToJson = (arr, obj, i) => {
    if (i == arr.length - 1) {
      if (Array.isArray(obj)) {
        obj.push(arr[i])
        return obj
      }
      else
        return [arr[i]]
    }
    else {
      if (arr[i] == '-' || arr[i] == '') {
        return this.csvToJson(arr, obj, i + 1)
      }
      else {
        if (obj[arr[i]] == null) { obj[arr[i]] = {}; }
        obj[arr[i]] = csvToJson(arr, obj[arr[i]], i + 1)
        return obj
      }
    }
  }
  const parseCsvData = (data) => {
    try {
      data.splice(0, 1)
      let dict = {}
      for (let obj of data) {
        csvToJson(obj, dict, 0)
      }
      setData({ reasons: dict })
    }
    catch (err) {
      alert(err)
    }
  }

  // const handleChangeFile = e => {
  //   let reader = new FileReader()
  //   if (e.target.files.length > 0) {
  //     const filename = e.target.files[0].name

  //     reader.onload = event => {
  //       const csvData = PapaParse.parse(
  //         event.target.result,
  //         Object.assign({}, {
  //           error: ((err) => alert(err)),
  //           encoding: 'UTF-8',
  //         }),
  //       )
  //       parseCsvData(csvData.data)
  //       setData({ filename })
  //     }

  //     reader.readAsText(e.target.files[0], 'UTF-8')
  //   }
  // }
  let dispatch = useDispatch()
  const onSubmit = async (values) => {
    let { plant = null, line = null, machine = null } = JSON.parse(localStorage.getItem('current'))

    let value = {
      lineId: current?.line?.id,
      lineName: current?.line?.lineName,
        hallName: current?.line?.hallName,
        currentShiftName: current?.shift?.name,
        // userId: currentUser?.id,
        // email: currentUser?.email,
        machine: current?.machine?.machineName,
        plantName: plant?.plantName,
        plantId: current?.plant?._id,
        updatedAt: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
        action: 'Line Setting Updated',
        detailsAfter: {...values},
        values
    }
    let productionLine = {...line};
    productionLine.lineName = values.lineName;
    productionLine.hallName = values.hallName;

    if(current?.machine && current?.machine.displayName !='Default'){
    let machines = line.machines;
      for(let x= 0;x<machines.length;x++){
        if(productionLine.machines[x].machineName == machine.machineName)
        productionLine.machines[x].displayName = values.displayName;

      }
    }
    else
    productionLine.defaultLineName = values?.defaultLineName || productionLine?.defaultLineName;

    let updatedLog = {
      lineName:values?.lineName||line?.lineName,
      hallName:values?.hallName||line?.hallName,
      defaultLineName:values?.defaultLineName||line?.defaultLineName,
      machines:(current.machine)?productionLine.machines:line?.machines
    }
    //console.log(value)
    let body = {
      plantId:plant?._id,
      updatedAt: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
      _id: line?._id,
      ...updatedLog
    }
      //await createAlert(dispatch, { ...values, lineOps }, current)
  onDowntimeValuesSubmit(dispatch, body)
  }
const LineForm = () => {
  return(
  <Row gutter={6}>
        <Col span={12}>
          <p>{line}</p>
            <Form.Item
              name={'lineName'} 
            >
               <Input 
               defaultValue={current?.line?.lineName} 
               className="sc-form-input boxBorder boxBorderRad" />
            </Form.Item>
        </Col>
        {current.machine && (
          <Col span={12}>
          <p>{machineName}</p>
            <Form.Item
              name={current.machine && current.machine?.displayName !='Default' ? 'displayName':'defaultLineName'} 
            >
               <Input 
               defaultValue={(current.machine && current.machine.displayName !='Default') ? current?.machine?.displayName:current?.line?.defaultLineName} 
               className="sc-form-input boxBorder boxBorderRad" />
            </Form.Item>
        </Col>
        )}
        <Col span={12}>
          <p>{target_oee}</p>
            <Form.Item
              name='targetOee'
            >
           <Input 
           defaultValue={lineInfoData.targetOee}
           className="sc-form-input boxBorder boxBorderRad"  />
              </Form.Item>
        </Col>
        {(current?.machine && current?.machine?.displayName =='Default') && (
        <Col span={12}>
          <p>{defaultMachine}</p>
            <Form.Item
              name='defaultLineName'
            >
              <Input className="sc-form-input boxBorder boxBorderRad"  />
            </Form.Item>
        </Col>)}
        <Col span={12}>
          <p>{timeZone}</p>
            <Form.Item
              name='timezone'
            >
              <Select
                  // className="sc-form-input boxBorder boxBorderRad"
                  showSearch
                  placeholder="Select timezeone"
                  
                >
                  {Object.keys(timeZones).map(zone => (
                    <Option key={timeZones[zone]} value={timeZones[zone]}>
                      {/* <FormattedMessage id={zone} /> */}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
        </Col>
        <Col span={12}>
          <p>{hallNAme}</p>
            <Form.Item
              name='hallName'
            >
              <Input 
              defaultValue={lineInfoData.hallName}
              className="sc-form-input boxBorder boxBorderRad"  />
            </Form.Item>
        </Col>
        <Col span={12}>
          <p>{importReason}</p>
          <Form.Item 
              name='Import Reason'
          >
        <div className="lineOp_head dflex alignCenter justifySB">
        <div className="dflex alignCenter justifyCenter gap10">
        <label for='SelectFIle' className="btnWhite">Import CSV </label>
          <input
            theme={"white"}
            type="file"
            size="30"
            id='SelectFIle'
            // onChange={e => handleChangeFile(e)}
            accept='.csv, text/csv'
            style={{ display: "none" }}
          />
          {/* {filename ? <Tag>{filename}</Tag> : <div/>} */}
          <ButtonComp theme={"blue"} text="Download Template" 
          // icon={<RedoOutlined />} 
          />
        </div>
      </div>
          </Form.Item>
        </Col>
        {/* {canPerformAction(current, access_capabilities.canEditLineSettings) && ( */}
        <Form.Item className="width100P dflex alignCenter justifyFE">
          <ButtonComp
            htmlType="submit"
            theme="blue"
            icon={<CheckCircleOutlined />}
            text="Save"
          />
        </Form.Item>
        {/* )} */}
      </Row>
  )
  }
  return (
    <>
    <div className="APIRestPoints-div1 boxBorderRad boxBorder p10">
      <Form name="basic" layout="vertical">
        {RestLineInformationPoints}
      </Form>
    </div>
    <div>
      <Form onFinish={onSubmit}>
      <LineForm />
      </Form>
    </div>
    </>
  );
};

export default LineInformation;
